import { toast } from "react-toastify";
import NEW_API from "../../Api/NewApi";
import { refetchCommandeItem } from "./commandes";

export const getCatalogue =
  (activeTab, productsactiveTab, searchInput, signal, hasLoading = true) =>
  async (dispatch, getState) => {
    try {
      const { locale } = getState().localeReducer;
      const params = {
        ...(activeTab === "Produits"
          ? { type: 1, gamme: productsactiveTab }
          : { type: activeTab }),
        ...(searchInput && { search: searchInput }),
        locale,
      };
      hasLoading && dispatch({ type: "CATALOGUE_LOADING" });
      const { data } = await NEW_API.get("/api/fetchcatalogue", {
        params,
        signal,
      });
      dispatch({ type: "CATALOGUE_SUCCESS", payload: data.data.catalogue });
      dispatch({ type: "CART_SUCCESS", payload: data.data.carts });
    } catch (error) {
      if (error.name === "CanceledError") return;
      dispatch({ type: "CATALOGUE_ERROR" });
    }
  };

export const switchCarts = (cartId) => async (dispatch) => {
  try {
    localStorage.setItem("selectedCart", cartId);
    dispatch({ type: "SWITCH_CARTS", payload: cartId });
  } catch (error) {
    console.log(error);
    dispatch({ type: "CATALOGUE_ERROR" });
  }
};

export const createCart =
  ({ activeTab, searchInput, productsactiveTab }) =>
  async (dispatch) => {
    try {
      dispatch({ type: "NEW_CART_LOADING" });

      await NEW_API.post(`/api/createCart`);
      dispatch(getCatalogue(activeTab, productsactiveTab, searchInput));
    } catch (error) {
      dispatch({ type: "CART_ERROR" });
    }
  };

export const addToCart =
  (packingId, qte, { activeTab, searchInput, productsactiveTab }) =>
  async (dispatch, getState) => {
    try {
      const { cart } = getState().catalogueReducer;
      dispatch({ type: "CART_LOADING", payload: packingId });
      if (qte === 1 && qte) {
        await NEW_API.post(`/api/addToCart`, {
          data: { packingId, commandeId: cart.id },
        });
      } else {
        await NEW_API.post(`/api/addToCartMultiple`, {
          data: { packingId, qte, commandeId: cart.id },
        });
      }

      await dispatch(
        getCatalogue(
          activeTab,
          productsactiveTab,
          searchInput,
          undefined,
          false,
        ),
      );
      await NEW_API.put(`/api/update-packing-status`, {
        data: { packings: [packingId] },
      });
    } catch (error) {
      dispatch({ type: "CART_ERROR" });
    }
  };

export const removeFromCart =
  (packingId, { activeTab, searchInput, productsactiveTab }) =>
  async (dispatch) => {
    try {
      dispatch({ type: "CART_LOADING", payload: packingId });
      const { data } = await NEW_API.delete(
        `/api/commandes/packings/${packingId}`,
      );
      await dispatch(getCatalogue(activeTab, productsactiveTab, searchInput));
      if (data.deleted) return;
      await NEW_API.put(`/api/update-packing-status`, {
        data: { packings: [packingId] },
      });
    } catch (error) {
      dispatch({ type: "CART_ERROR" });
    }
  };

export const updatePacking =
  (packingIds, data, { activeTab, searchInput, productsactiveTab }) =>
  async (dispatch) => {
    try {
      for (let i = 0; i < packingIds.length; i++) {
        const packingId = packingIds[i];

        dispatch({ type: "CART_LOADING", payload: packingId });
        await NEW_API.put(`/api/packings/${packingId}`, {
          data: data,
        });
      }
      dispatch(getCatalogue(activeTab, productsactiveTab, searchInput));
    } catch (error) {
      console.log({ error });
      dispatch({ type: "CART_ERROR" });
    }
  };
export const updateCart =
  (cartId, data, packings = []) =>
  async (dispatch) => {
    try {
      dispatch({ type: "CART_LOADING", payload: cartId });
      await NEW_API.put(`/api/commandes/${cartId}`, {
        data: {
          ...data,
        },
      });
      if (Array.isArray(packings)) {
        for (const packing of packings) {
          if (packing?.globalDiscount > 0) {
            const globalDiscount =
              data.particulier && packing?.globalDiscount > 0
                ? packing?.model?.discountTTC
                : packing?.model?.discountHT;

            await NEW_API.put(`/api/packings/${packing.id}`, {
              data: {
                globalDiscount: globalDiscount || 0,
              },
            });
          }
        }
      }
      await dispatch(refetchCart());
    } catch (error) {
      console.log(error);
      dispatch({ type: "CART_ERROR" });
    }
  };

/**
 * Scénario B D1: links the cart (a partner purchase order) to a customer
 * project and quote (nulls unlink). The API keeps the customer order of that
 * quote pointing at it (partnerOrder → the partner's margin), also when the
 * customer order is created later.
 */
export const linkCartToQuote =
  (cartId, { projectId, quoteId }, t) =>
  async (dispatch) => {
    try {
      dispatch({ type: "CART_LOADING", payload: cartId });
      await NEW_API.put(`/api/commandes/${cartId}/quote-link`, {
        data: { projectId: projectId ?? null, quoteId: quoteId ?? null },
      });
      await dispatch(refetchCart());
    } catch (error) {
      console.log(error);
      dispatch({ type: "CART_ERROR" });
      toast.error(
        t(
          error?.response?.status === 409
            ? "This cart holds the units of your customer's order: it stays linked to that quote."
            : "An error has occurred!",
        ),
      );
    }
  };

export const refetchCart = () => async (dispatch, getState) => {
  try {
    const { locale } = getState().localeReducer;
    const { cart } = getState().catalogueReducer;

    const { data } = await NEW_API.get(
      `/api/refetchCart?commandeId=${cart.id}&locale=${locale}`,
    );

    dispatch({
      type: "REFETCH_CART",
      payload: data.data.cart,
    });
  } catch (error) {
    dispatch({ type: "CART_ERROR" });
  }
};

export const generateInvoice =
  (commandeId, refetchCommande = false, t) =>
  async (dispatch) => {
    try {
      if (refetchCommande) {
        dispatch({ type: "GENERATE_FACTURE_LOADING", payload: commandeId });
      } else {
        dispatch({ type: "CART_LOADING", payload: 1 });
      }
      await NEW_API.post(`/api/${"generatefacture"}`, {
        data: { commandeId: commandeId },
      });

      dispatch({ type: "GENERATE_FACTURE_SUCC" });

      if (refetchCommande) {
        dispatch(refetchCommandeItem(commandeId));
      } else {
        dispatch(refetchCart(commandeId));
      }
      toast.success(t("Invoice successfully generated"));
    } catch (error) {
      dispatch({ type: "CART_ERROR" });
      dispatch({ type: "GENERATE_FACTURE_ERR" });
    }
  };

export const generateBonDeCommande =
  (commandeId, refetchCommande = false, t) =>
  async (dispatch) => {
    try {
      if (refetchCommande) {
        dispatch({ type: "GENERATE_BON_LOADING", payload: commandeId });
      } else {
        dispatch({ type: "CART_LOADING", payload: 1 });
      }
      await NEW_API.post(`/api/generateBonDeCommande`, {
        data: { commandeId: commandeId },
      });
      if (refetchCommande) {
        await dispatch(refetchCommandeItem(commandeId));
      } else {
        await dispatch(refetchCart(commandeId));
      }
      toast.success(t("Order form successfully generated"));
    } catch (error) {
      dispatch({ type: "CART_ERROR" });
    }
  };

export const generateAvoir =
  (commandeId, refetchCommande = false, t) =>
  async (dispatch) => {
    try {
      if (refetchCommande) {
        dispatch({ type: "GENERATE_AVOIR_LOADING", payload: commandeId });
      } else {
        dispatch({ type: "CART_LOADING", payload: 1 });
      }
      await NEW_API.post(`/api/generateAvoir`, {
        data: { commandeId: commandeId },
      });
      if (refetchCommande) {
        dispatch(refetchCommandeItem(commandeId));
      } else {
        dispatch(refetchCart(commandeId));
      }
      toast.success(t("Credit successfully generated"));
    } catch (error) {
      dispatch({ type: "CART_ERROR" });
    }
  };

export const generateDepositInvoice =
  (commandeId, paymentId, refetchCommande = false, t, lastDepositAmount = 0) =>
  async (dispatch) => {
    // return;
    try {
      if (refetchCommande) {
        dispatch({ type: "GENERATE_DEPOSIT_LOADING", payload: commandeId });
      } else {
        dispatch({ type: "CART_LOADING", payload: 1 });
      }

      await NEW_API.post(`/api/generateDepositInvoice`, {
        data: { commandeId, paymentId: +paymentId, lastDepositAmount },
      });
      dispatch({ type: "GENERATE_DEPOSIT_SUCC", payload: commandeId });
      // toast.success(t("Deposit invoice successfully generated"));
    } catch (error) {
      dispatch({ type: "CART_ERROR" });
      dispatch({ type: "GENERATE_DEPOSIT_ERROR", payload: commandeId });
    }
  };

export const deleteDepositInvoice = (invoiceId) => async (dispatch) => {
  dispatch({ type: "GENERATE_DEPOSIT_LOADING" });

  try {
    await NEW_API.delete(`api/acompte-factures/${invoiceId}`);
  } catch (error) {
    console.log(error);
    dispatch({ type: "GENERATE_DEPOSIT_ERROR" });
  }
};

export const updateFacture =
  (factureId, data, commandeId, t, orderWithPayments) => async (dispatch) => {
    try {
      await NEW_API.put(`/api/factures/${factureId}`, {
        data: data,
      });

      dispatch(generateInvoice(commandeId, false, t));
    } catch (error) {
      dispatch({ type: "CART_ERROR" });
    }
  };

export const updateBonDeCommande =
  (bonId, data, commandeId) => async (dispatch) => {
    try {
      await NEW_API.put(`/api/bon-de-commandes/${bonId}`, {
        data: data,
      });

      dispatch(generateBonDeCommande(commandeId));
    } catch (error) {
      dispatch({ type: "CART_ERROR" });
    }
  };

export const updateCredit =
  (creditId, data, commandeId, t) => async (dispatch) => {
    try {
      await NEW_API.put(`/api/avoirs/${creditId}`, {
        data: data,
      });

      dispatch(generateAvoir(commandeId, false, t));
    } catch (error) {
      dispatch({ type: "CART_ERROR" });
    }
  };

export const validateCommande =
  (setShowDialog, commande) => async (dispatch) => {
    dispatch({ type: "CART_LOADING", payload: commande.id });

    try {
      // if (!commande.bon_de_commande) {
      await dispatch(generateBonDeCommande(commande.id));
      // }
      await NEW_API.post(`/api/validateCommande`, {
        data: {
          commandeId: commande.id,
        },
      });
      dispatch({ type: "CART_VALIDATED" });
      await NEW_API.put(`/api/update-packing-status`, {
        data: { packings: commande?.packings.map((p) => p.id) },
      });
      setShowDialog && setShowDialog(true);
    } catch (error) {
      dispatch({ type: "CART_ERROR" });
    }
  };

export const removeOrderFromCartsList =
  (cartId, nextSelectedCart) => async (dispatch) => {
    try {
      await dispatch(
        updateCart(cartId, {
          ongoingCreator: null,
        }),
      );

      await dispatch({
        type: "REMOVE_FROM_CARTS",
        payload: cartId,
      });

      localStorage.setItem("selectedCart", nextSelectedCart);
      dispatch(switchCarts(nextSelectedCart));
      nextSelectedCart === cartId && localStorage.removeItem("selectedCart");
    } catch (error) {
      console.log({ error });
    }
  };
